import Dexie, { Table } from "dexie";
import { Vector3Tuple } from "three";

export interface IfcTable {
  id: string;
  position: Vector3Tuple;
  rotation: Vector3Tuple;
  scale: Vector3Tuple;
  fragments: Blob;
}

class ModdedDexie extends Dexie {
  /** See https://dexie.org/docs/Tutorial/React#using-typescript */
  models!: Table<IfcTable>;

  constructor() {
    super("scaffcalc-models-db");
    this.version(1).stores({
      models: "id, position, rotation, scale, fragments",
    });
  }
}

/** Wrapped ModdedDexie to expose used functions */
class DbIfc extends ModdedDexie {
  public saveToDb = async (item: IfcTable, id: string) => {
    await this.deleteFromDb(id);
    await this.models.add(item, id);
  };

  public saveOrUpdateToDb = async (item: IfcTable, id: string) => {
    await this.models.put(item, id);
  };

  public readFromDb = async (id: string) => {
    return this.models.where("id").equals(id).toArray();
  };

  public readAllFromDb = async () => {
    return this.models.toArray();
  };

  public deleteFromDb = async (id: string) => {
    await this.models.delete(id);
  };

  public clearDb = async () => {
    await this.models.clear();
  };
}

export default DbIfc;
